<button mat-button *ngIf="!icon" (click)="openDialog()" >Delete</button>
<button mat-menu-button mat-menu-item *ngIf="icon" (click)="openDialog()" >
    <mat-icon >delete</mat-icon>
    <span>Delete</span>
</button>
